/**
 * 从服务器获取日期
 */
export function getServeTime() {
  let obj = { apiTime: '', time: '' }
  var req = new XMLHttpRequest()
  req.open('GET', location, false)
  req.send(null)
  let dateTime = new Date(req.getResponseHeader('Date'))
  let year = dateTime.getFullYear()
  let month = String(dateTime.getMonth() + 1).padStart(2, '0')
  let day = String(dateTime.getDate()).padStart(2, '0')
  obj.apiTime = year + '-' + month + '-' + day
  obj.time = year + '年' + month + '月' + day + '日'
  return obj
}
